import http from 'utils/http';
import { NotificationPreferenceScope, NotificationPreferencesResponse, NotificationPreferenceValues } from './types';

export function getNotificationPreferences(
  scope: NotificationPreferenceScope
): Promise<NotificationPreferencesResponse> {
  return http.get(`${scope}/notification_preferences`);
}

export function updateNotificationPreferences(
  scope: NotificationPreferenceScope,
  preferences: Record<string, NotificationPreferenceValues>
): Promise<NotificationPreferencesResponse> {
  return http.patch(`${scope}/notification_preferences`, { preferences });
}
